<template>
    <basic-slider v-if="defaultImage >= 0 "
                  :images="listOfImages"
                  :default="defaultImage"
                  :nextButton="this.titleNext"
                  :previousButton="this.titlePrevious"
    >
    </basic-slider>
</template>

<script>
  import utilities from '../../../api/utilities';
  import BasicSlider from '../../slider/BasicSlider.vue';

  export default {
    components: {
      BasicSlider
    },

    props: [
      'images',
      'titleNext',
      'titlePrevious'
    ],

    created () {
      // console.log(this.images);
    },

    computed: {
      api_url () {
        return utilities.apiURL();
      },

      defaultImage () {
        let images = this.images || {};
        return images.hasOwnProperty('default') && images.default !== null ? images.default : 0;
      },

      listOfImages () {
        let images = this.images || {};

        if (images.hasOwnProperty('default')) {
          return images.listOfImages.map((e) => {
            return this.getPath(e);
          });
        }

        if (Array.isArray(images) && images.length) {
          return images.map((e) => {
            return this.getPath(e);
          });
        }

        return ['/static/default_product.jpg'];
      },
    },

    methods: {
      getPath (img) {
        return this.api_url + 'data/' + img;
      },
    }
  };
</script>



// WEBPACK FOOTER //
// images.vue?d969b2da